/**
 * @desc sku报价提交审批
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export type Response = defs.srm.Response;
export function request(id: number, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/srm/supplierQuotation/submitSupplierQuote/${id}`, {
      method: "POST",

      ...options,
    }),
  );
}
